import React from "react";
import "./ThankYou.scss";
import Studio from "../../Animations/Studio/Studio";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import { ga_push } from "../../../services/analytics";
const ThankYou = () => {
  const { didChoose } = useContext(AppContext);
  const GoToQuiz = () => {
    ga_push("navigation_events", "Navigation", "Go To The Quizz");
    window.location.href = "https://z.ynet.co.il/mShort/generics/quizzes/glgltzint/";

  }
  return (
    <div className="thank-you-page">
      <div className="cube">
        <h2>{didChoose ? "כבר הצבעתם :)" : "הצבעתכם נרשמה"}</h2>

        <h3>כל קול חשוב!</h3>

        <h3>          רוצים לנסות ולזכות בטלוויזית NanoCell ובמקרן קול
          
          של
        </h3>
        <div className="lg"></div>
        <h3>המשיכו לחידון!</h3>
      </div>
      <div className="side-container">
        <h2>{didChoose ? "כבר הצבעתם :)" : "הצבעתכם נרשמה"}</h2>
        <h3>
          {/* {didChoose ? "כל קול חשוב!" : "!כל קול חשוב! "} */}
          כל קול חשוב!
          
          רוצים לנסות ולזכות בטלוויזית NanoCell ובמקרן קול
          
          של
          <span className="lg"></span>
          <br/>
           המשיכו לחידון!
        </h3>
        <button onClick={() => GoToQuiz()}>לחידון</button>
      </div>
      <Studio />
      {/* <Footer/> */}
    </div>
  );
};

export default ThankYou;
